import styled from "styled-components";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export const Sections = styled.div`
  display: flex;
  padding: 2% 4%;
  @media (max-width: 750px) {
    flex-direction: column;
  }
`;

export const CenterPageSection = styled.div`
  width: 100%;
  margin-bottom: 1%;
  @media (max-width: 750px) {
    width: 100%;
  }
`;
export const ProjectsPageContainer = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: auto;
  margin: 0 auto;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;

export const ProjectsHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
`;

export const ProjectsTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  position: relative;

  &::after {
    content: "";
    display: block;
    height: 3px;
    background: #fe2f67;
    margin-top: 6px;
    border-radius: 2px;
  }
`;

export const CreateProjectButton = styled.button`
  background-color: transparent;
  color: #fe2f67;
  border: none;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    text-decoration: underline;
  }
`;

export const ProjectsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ProjectCard = styled.div`
  display: flex;
  margin-bottom: 1rem;
  flex-direction: row;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  min-height: 100px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 2px solid #fe2f67;
    outline-offset: 2px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ProjectInfoLeft = styled.div`
  background-color: #ececec;
  flex: 3;
  display: flex;
  align-items: center;
  padding: 1.2rem;

  @media (max-width: 600px) {
    padding: 0.8rem;
  }
`;

export const ProjectInfoRight = styled.div`
  background-color: #fff;
  flex: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem;

  @media (max-width: 600px) {
    padding: 0.8rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  
  `;
export const ProjectCircle = styled.div<{ color?: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${({ color }) => color || "#FE2F67"};
  margin-right: 0.5rem;
`;

export const ProjectText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProjectName = styled.p`
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
`;

export const ProjectDate = styled.p`
  font-size: 0.8rem;
  color: #9c9c9c;
  margin: 3px 0 0;
  display: flex;
  align-items: center;
`;

export const ProjectFundraisingText = styled.p`
  font-size: 0.85rem;
  color: #767676;
  margin: 0;
  font-weight: 500;
`;

export const FundraisingBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
`;

export const FundraisingBarFill = styled.div<{ percentage: number }>`
  width: ${({ percentage }) => `${percentage}%`};
  height: 100%;
  background-color: #fe2f67;
  border-radius: 4px;
`;

export const ArrowIcon = styled(KeyboardArrowRightIcon)`
  color: #999999;
  cursor: pointer;
  &:hover {
    color: #555;
  }
`;

export const ProjectNoneCreatedDiv = styled.div`
  width: 100%;
  background-color: #fff1f1;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 8px 10px 6px -5px rgb(193 193 193 / 80%);
  padding: 1.5rem;
  margin-top: 1rem;
  text-align: center;
  box-sizing: border-box;
`;

export const ProjectNoneTitle = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
`;

export const ProjectNoneSubtitle = styled.p`
  margin: 0;
  font-size: 0.85rem;
  font-weight: 500;
  color: #757575;
  max-width: 20rem;
`;
export const FundraisingInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
